<form [formGroup]="newSearchForm" class="new-search-form">
    <div class="row mb-3 new-search-form__row">
        <label class="col-sm-1 new-search-form__label" for="title">{{ 'TITLE' | translate }}</label>
        <div class="col-sm-4">
            <input type="text" class="form-control" formControlName="title"
                [ngClass]="{ 'is-invalid': submitted && form.title.errors }" [placeholder]="'ENTER_SEARCH_TITLE' | translate">
            <div *ngIf="submitted && form.title.errors" class="invalid-feedback">
                <div *ngIf="form.title.errors.required">{{ 'TITLE_REQUIRED' | translate }}</div>
            </div>
        </div>
    </div>
    <div class="row mb-3 new-search-form__row">
        <label class="col-sm-1 new-search-form__label" for="resultType">{{ 'RESULT_TYPE' | translate }}</label>
        <div class="col-sm-4">
            <ng-select class="new-search-form__select"
                [ngClass]="{ 'is-invalid': submitted && form.resultType.errors }"
                (change)="onResultTypeChange(form.resultType.value)" formControlName="resultType"
                [clearable]="false" [searchable]="false">
                <ng-option *ngFor="let p of allResultTypes" [value]="p">{{ resultTypeLabelKeyMap[p] | translate }}</ng-option>
            </ng-select>
            <div *ngIf="submitted && form.resultType.errors" class="invalid-feedback">
                <div *ngIf="form.resultType.errors.required">{{ 'RESULT_TYPE_REQUIRED' | translate }}</div>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-sm-5">
            <div class="new-search-form__actions">
                <div class="new-search-form__actions-spacer">
                </div>
                <div class="new-search-form__actions-item">
                    <button type="button" class="blue-button new-search-form__button"
                        (click)="saveClicked()">{{ 'SAVE' | translate }}</button>
                </div>
                <div>
                    <button type="button" class="gray-button new-search-form__button"
                        (click)="cancelClicked()">{{ 'CANCEL' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</form>

<div class="dv-custom-navs">
    <ul ngbNav #nav="ngbNav" [destroyOnHide]="false" [(activeId)]="active" class="nav-tabs details-nav-tabs search-builder-tabs">
        <li [ngbNavItem]="1" [disabled]="campaignDisabled" *ngIf="campaignVisible" [class.rm-tab-active]="active === 1" [class.search-builder-tab--disabled]="campaignDisabled">
            <a ngbNavLink [class.search-builder-tab-link--disabled]="campaignDisabled">
                <i-feather name="globe"></i-feather><label>{{ resultTypeLabelKeyMap['Campaign'] | translate }}</label>
            </a>
            <ng-template ngbNavContent>
                <div class="details-tab-surface details-tab-surface--tight">
                    <app-new-search-fields [formGroup]="newSearchForm" [rowsInput]="campaignColumns" [submitted]="submitted"
                        [disabled]="campaignDisabled"></app-new-search-fields>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [disabled]="clientDisabled" *ngIf="clientVisible" [class.rm-tab-active]="active === 2" [class.search-builder-tab--disabled]="clientDisabled">
            <a ngbNavLink [class.search-builder-tab-link--disabled]="clientDisabled">
                <i-feather name="user"></i-feather><label>{{ resultTypeLabelKeyMap['Client'] | translate }}</label>
            </a>
            <ng-template ngbNavContent>
                <div class="details-tab-surface details-tab-surface--tight">
                    <app-new-search-fields [formGroup]="newSearchForm" [rowsInput]="clientsColumns" [submitted]="submitted"
                        [disabled]="clientDisabled"></app-new-search-fields>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="3" [disabled]="leadDisabled" *ngIf="leadVisible" [class.rm-tab-active]="active === 3" [class.search-builder-tab--disabled]="leadDisabled">
            <a ngbNavLink [class.search-builder-tab-link--disabled]="leadDisabled">
                <i-feather name="bar-chart-2"></i-feather><label>{{ resultTypeLabelKeyMap['Lead'] | translate }}</label>
            </a>
            <ng-template ngbNavContent>
                <div class="details-tab-surface details-tab-surface--tight">
                    <app-new-search-fields [formGroup]="newSearchForm" [rowsInput]="leadColumns" [submitted]="submitted"
                        [disabled]="leadDisabled"></app-new-search-fields>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="4" [disabled]="userDisabled" *ngIf="userVisible" [class.rm-tab-active]="active === 4" [class.search-builder-tab--disabled]="userDisabled">
            <a ngbNavLink [class.search-builder-tab-link--disabled]="userDisabled">
                <i-feather name="server"></i-feather><label>{{ resultTypeLabelKeyMap['User'] | translate }}</label>
            </a>
            <ng-template ngbNavContent>
                <div class="details-tab-surface details-tab-surface--tight">
                    <app-new-search-fields [formGroup]="newSearchForm" [rowsInput]="userColumns" [submitted]="submitted"
                        [disabled]="userDisabled"></app-new-search-fields>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="5" [disabled]="companyDisabled" *ngIf="companyVisible" [class.rm-tab-active]="active === 5" [class.search-builder-tab--disabled]="companyDisabled">
            <a ngbNavLink [class.search-builder-tab-link--disabled]="companyDisabled">
                <i-feather name="briefcase"></i-feather><label>{{ resultTypeLabelKeyMap['Company'] | translate }}</label>
            </a>
            <ng-template ngbNavContent>
                <div class="details-tab-surface details-tab-surface--tight">
                    <app-new-search-fields [formGroup]="newSearchForm" [rowsInput]="companyColumns" [submitted]="submitted"
                        [disabled]="companyDisabled"></app-new-search-fields>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="6" [disabled]="prospectDisabled" *ngIf="prospectVisible" [class.rm-tab-active]="active === 6" [class.search-builder-tab--disabled]="prospectDisabled">
            <a ngbNavLink [class.search-builder-tab-link--disabled]="prospectDisabled">
                <i-feather name="server"></i-feather><label>{{ resultTypeLabelKeyMap['Prospect'] | translate }}</label>
            </a>
            <ng-template ngbNavContent>
                <div class="details-tab-surface details-tab-surface--tight">
                    <app-new-search-fields [formGroup]="newSearchForm" [rowsInput]="prospectColumns" [submitted]="submitted"
                        [disabled]="prospectDisabled"></app-new-search-fields>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="7" [disabled]="tagDisabled" *ngIf="tagVisible" [class.rm-tab-active]="active === 7" [class.search-builder-tab--disabled]="tagDisabled">
            <a ngbNavLink [class.search-builder-tab-link--disabled]="tagDisabled">
                <i-feather name="tag"></i-feather><label>{{ resultTypeLabelKeyMap['Tag'] | translate }}</label>
            </a>
            <ng-template ngbNavContent>
                <div class="details-tab-surface details-tab-surface--tight">
                    <app-new-search-fields [formGroup]="newSearchForm" [rowsInput]="tagColumns" [submitted]="submitted"
                        [disabled]="tagDisabled"></app-new-search-fields>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="8" [disabled]="taskDisabled" *ngIf="taskVisible" [class.rm-tab-active]="active === 8" [class.search-builder-tab--disabled]="taskDisabled">
            <a ngbNavLink [class.search-builder-tab-link--disabled]="taskDisabled">
                <i-feather name="list"></i-feather><label>{{ resultTypeLabelKeyMap['Task'] | translate }}</label>
            </a>
            <ng-template ngbNavContent>
                <div class="details-tab-surface details-tab-surface--tight">
                    <app-new-search-fields [formGroup]="newSearchForm" [rowsInput]="taskColumns" [submitted]="submitted"
                        [disabled]="taskDisabled"></app-new-search-fields>
                </div>
            </ng-template>
        </li>

    </ul>
    <div [ngbNavOutlet]="nav" class="details-nav-outlet"></div>
</div>